import {
  Button,
  Grid,
  TextField,
  Paper,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import ResponsiveDrawer from "../../components/ClippedResponsiveDrawer";
import { AxiosRequestConfig } from "axios";
import { useEffect, useState } from "react";
import { AXIOS_INSTANCE, BASE_URL } from "../../App";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import TableAbstraction from "../../componentUtils/TableAbstraction"

interface ReportingState {
  isLoaded: boolean,
  data: ReportingRow[],
}

interface ReportingRow {
  client_id: number;
  sales_org: string;
  sales_office: string;
  route: string;
  load_date: Date;
  customer_num: string;
  material_num: string;
  consignment: number;
  average_consumption: number;
  quantity: number;
}

interface Selection {
  deliveringPlant: string;
  route: string;
  loadDate: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    cont: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    grid: {
      marginLeft: theme.spacing(1),
    },
    load: {
      textAlign: "center",
      justify: "center",
    },
    root: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    rootContainer: {
      [theme.breakpoints.down("md")]: {
        padding: 0,
        paddingTop: theme.spacing(1),
      },
    },
    tokenBlock: {
      width: "500px",
      overflowWrap: "break-word",
    },
    typography: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
  })
);

async function getReportingData(salesOrg: string, deliveringPlant: string, route: string, date: string) {
  const configReporting: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      deliveringPlant: deliveringPlant,
      route: route,
      date: date,
    },
    url: `${BASE_URL}/api/reporting/planning`,
  };

  return await AXIOS_INSTANCE(configReporting).then((res: any) => res.data);
}

export default function PlanningReporting() {
  const classes = useStyles();
  const [defaultSalesOffice, setDefaultSalesOffice] = useLocalStorage("SETTINGS.defaultSalesOffice", '');
  const [state, setState] = useState<ReportingState>({
    isLoaded: false,
    data: [],
  });

  const today = new Date().toISOString().split('T')[0];

  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [selection, setSelection] = useState<Selection>({
    deliveringPlant: defaultSalesOffice||"", route: "", loadDate: today
  });

  const handleFormChange = (event: any) => {
    event.persist();
    setSelection({
      ...selection,
      [event.target.name]
          : event.target.value
    });
  }

  const onSelectionChange = () => {
    const sOrg = salesOrg.toString();
      getReportingData(sOrg, selection.deliveringPlant, selection.route, selection.loadDate)
      .then((v) => {
        setState({isLoaded: true, data: v});
      })
  }


  return (
    <ResponsiveDrawer
      title="Reporting"
    >
      <div className={classes.rootContainer}>


      <Paper className={classes.cont}>
      <Grid className={classes.grid} container spacing={3}>
        <Grid item lg={3} md={3} xl={3} xs={3}>
          <TextField label="Delivery Plant" name="deliveringPlant" fullWidth={true} value={selection.deliveringPlant} onChange={handleFormChange} />
        </Grid>
        <Grid item lg={3} md={3} xl={3} xs={3}>
          <TextField label="Route" name="route" fullWidth={true} value={selection.route} onChange={handleFormChange} />
        </Grid>

        <Grid item lg={3} md={3} xl={3} xs={3}>
          <TextField label="Load Date" name="loadDate" fullWidth={true} type="date" value={selection.loadDate} onChange={handleFormChange} />
        </Grid>

        <Grid item className={classes.load} lg={3} md={3} xl={3} xs={3}>
          <Button onClick={() => onSelectionChange()}>Load Data</Button>
        </Grid>
      </Grid>
    </Paper>


        <TableAbstraction
          settingsKey="RPT_PLN"
                      options={{
                        serverSide: false,
                        responsive: "vertical",
                        selectableRows: "none",
                        tableHeightReducePx: 60,
                        rowsPerPage: 100,
                      }}
                      title="Planning Data to Backend"
                      columns={[
                        {
                          label: "Sales Office",
                          name: "sales_office",
                        },
                        {
                          label: "Delivery Plant",
                          name: "delivering_plant",
                        },
                        {
                          label: "Route",
                          name: "route",
                        },
                        {
                          label: "Load Date",
                          name: "load_date",
                        },       
                        {
                          label: "Customer #",
                          name: "customer_num",
                        },                        
                        {
                          label: "Material #",
                          name: "material_num",
                          options: {
                            customBodyRender: (value) => {
                              if (value) {
                                return (value.replace(/^0+/, ""));
                              }
                            }
                          }
                        },                           
                        {
                          label: "Consignment",
                          name: "consignment",
                        },                                             
                        {
                          label: "Avg Consumption",
                          name: "average_consumption",
                          options: {
                            customBodyRender: (value) => {
                              if (value) {
                                return (value.toFixed(2));
                              }
                            }
                          }
                        },
                        {
                          label: "Quantity",
                          name: "quantity",
                          options: {
                            searchable: false,
                            renderCell: (params) =>{
                              let item = params.row
                              if (item) {
                                var uom = "EA";
                                if (item.customer_num === "DRIVER" || item.customer_num === "DRVTOTAL") {
                                  uom = "CS";
                                }
                                return (
                                  item.quantity + " " + uom
                                );
                              }
                            },
                          },
                        },
                      ]}
                      data={state.data}
                    />
      </div>
    </ResponsiveDrawer>
  );
}
